/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lp_Login_Operationstitle2Inputs */

const en_coinvestments_lp_login_operationstitle2 = /** @type {(inputs: Coinvestments_Lp_Login_Operationstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facilitate operations`)
};

/**
* | output |
* | --- |
* | "Facilitate operations" |
*
* @param {Coinvestments_Lp_Login_Operationstitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_login_operationstitle2 = /** @type {((inputs?: Coinvestments_Lp_Login_Operationstitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Login_Operationstitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_login_operationstitle2(inputs)
});
export { coinvestments_lp_login_operationstitle2 as "coInvestments_lp_login_operationsTitle" }